import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExpertiseComponent } from './expertise/expertise.component';
import { ExpertiseListComponent } from './expertise-list/expertise-list.component';
import { ExpertiseTabComponent } from './expertise-tab/expertise-tab.component';

const routes: Routes = [
	{ path: '',  component: ExpertiseComponent, children: [
		{ path: '', redirectTo: 'list', pathMatch: 'full' },
		{ path: 'list',  component: ExpertiseListComponent },
		{ path: 'view/:id',  component: ExpertiseTabComponent }		
	]},
	
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpertiseRoutingModule { }
